import { categoryFromSlug } from './legacy-paths.js';
/** Cards on one page of /news. */
export const NEWS_PAGE_SIZE = 6;
/** Cards in the landing page's news section. */
export const LATEST_NEWS_LIMIT = 3;
/** A page number from the URL, or null when it is not a plain positive integer. */
export function parsePageParam(raw) {
    if (raw === undefined)
        return 1;
    if (!/^[1-9]\d{0,4}$/.test(raw))
        return null;
    return Number(raw);
}
/** The list one page of /news shows. */
export function newsListFilter(category, page) {
    return { ...(category ? { category } : {}), limit: NEWS_PAGE_SIZE, offset: (page - 1) * NEWS_PAGE_SIZE };
}
/** The list of posts a public address shows first, or null for none. */
export function postsFilterFor(pathname, search) {
    const path = pathname.replace(/\/+$/, '') || '/';
    if (path === '/')
        return { limit: LATEST_NEWS_LIMIT };
    const m = /^\/news(?:\/pages\/([^/]+))?$/.exec(path);
    if (!m)
        return null;
    const page = parsePageParam(m[1]);
    return page ? newsListFilter(categoryFromSlug(search.get('category')), page) : null;
}
/** The article slug of an address, or null. */
export function articleSlugOf(pathname) {
    const m = /^\/news\/([^/]+)\/?$/.exec(pathname);
    if (!m?.[1] || m[1] === 'pages')
        return null;
    try {
        return decodeURIComponent(m[1]);
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=public-boot.js.map